import { Heart, Users, Cpu } from "lucide-react";

export default function About() {
  const values = [
    {
      icon: <Users className="w-6 h-6" />,
      title: "Atendimento Humanizado",
      description:
        "Aqui você não é um número. Entendemos sua necessidade com escuta ativa e proximidade.",
    },
    {
      icon: <Cpu className="w-6 h-6" />,
      title: "Alta Tecnologia",
      description:
        "Unimos o calor humano com a frieza dos códigos perfeitos. Performance e qualidade técnica.",
    },
    {
      icon: <Heart className="w-6 h-6" />,
      title: "Parceria de Verdade",
      description:
        "Seu projeto é nosso projeto. Trabalhamos lado a lado para ver o seu negócio crescer.",
    },
  ];

  return (
    <section
      id="about"
      className="relative z-10 px-6 py-24 bg-slate-950/50 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto">
        {/* Texto Principal */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div className="space-y-6 animate-fade-in-up">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-purple-500/10 border border-purple-500/20 text-purple-300 text-xs font-semibold uppercase tracking-wider">
              Sobre Nós
            </div>

            <h2 className="text-4xl md:text-5xl font-bold">
              Seu Sucesso é <br />
              <span className="bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">
                Nosso Código
              </span>
            </h2>

            <div className="space-y-4 text-lg text-slate-300 leading-relaxed">
              <p>
                A <strong>Ralui Tech</strong> surgiu de uma necessidade clara no
                mercado: atendimento humanizado aliado à alta tecnologia.
                Acreditamos que cada projeto é único e merece dedicação total.
              </p>
              <p>
                Diferente de grandes agências onde você é apenas um número, aqui
                construímos pontes. Unimos a excelência técnica do
                desenvolvimento de software com uma escuta ativa para entender
                as dores reais do seu negócio.
              </p>
              <p className="font-semibold text-white">
                Somos a tecnologia por trás dos seus resultados.
              </p>
            </div>
          </div>

          {/* Elemento Visual (Cartão de Missão) */}
          <div className="relative group animate-fade-in-up animation-delay-200">
            {/* Efeito de brilho no fundo */}
            <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-blue-600 rounded-2xl blur-2xl opacity-20 group-hover:opacity-30 transition-opacity duration-500"></div>

            <div className="relative bg-slate-900/80 border border-white/10 rounded-2xl p-8 backdrop-blur-xl hover:border-purple-500/30 transition-colors">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-blue-500 rounded-full flex items-center justify-center text-white font-bold text-xl">
                  RL
                </div>
                <div>
                  <div className="text-white font-bold">Ralui Tech</div>
                  <div className="text-slate-400 text-sm">Desde 2026</div>
                </div>
              </div>

              <div className="space-y-4 font-mono text-sm text-slate-300">
                <div className="flex gap-2">
                  <span className="text-purple-400">const</span>
                  <span className="text-blue-400">missao</span>
                  <span className="text-white">=</span>
                  <span className="text-green-400">
                    "Transformar ideias em realidade";
                  </span>
                </div>
                <div className="flex gap-2">
                  <span className="text-purple-400">const</span>
                  <span className="text-blue-400">valores</span>
                  <span className="text-white">=</span>
                  <span className="text-yellow-400">
                    ["Transparência", "Qualidade", "Parceria"];
                  </span>
                </div>
                <div className="pt-2 text-slate-500">
                  // Estamos prontos para o seu projeto...
                  <span className="animate-pulse">|</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Grid de Valores */}
        <div className="grid md:grid-cols-3 gap-6 animate-fade-in-up animation-delay-400">
          {values.map((item, index) => (
            <div
              key={index}
              className="p-6 rounded-xl bg-white/5 border border-white/10 hover:border-purple-500/30 transition-all hover:-translate-y-1 hover:bg-white/10 group"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-purple-500/20 to-blue-500/20 rounded-lg flex items-center justify-center text-purple-400 mb-4 group-hover:scale-110 transition-transform">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold mb-2">{item.title}</h3>
              <p className="text-slate-400 text-sm">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
